// Human-readable, sentence-case label for an UPPER_SNAKE status enum.
// e.g. 'PENDING' → 'Pending', 'IN_REVIEW' → 'In review', 'COMPLETED' → 'Completed'.
export function statusLabel(status: string): string {
  return status
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
}
